import { render } from "./health_check.vue?vue&type=template&id=42d2404f&scoped=true"
import script from "./health_check.vue?vue&type=script&lang=js"
export * from "./health_check.vue?vue&type=script&lang=js"

import "./health_check.vue?vue&type=style&index=0&id=42d2404f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d2404f"]])

export default __exports__